var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
        _vm.$style.block,
        _vm.scroll && _vm.$style.scroll,
        _vm.scrollMobileOnly && _vm.$style.scrollMobileOnly,
        _vm.padded && _vm.$style.blockPadded,
    ]},_vm._l((_vm.shows),function(show,index){return _c('ShowGridTile',{key:show.id + index,class:_vm.$style.tile,attrs:{"show":show,"index":index}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }